import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.OPEN_ADD_HOMEPAGE_ITEM_MODAL)
    .reduce((state, action) => {
        state.showingAddHomepageItemModal = true;
        state.columnId = action.columnId;
        state.sectionId = action.sectionId;
    })
    .forType(Types.CLOSE_ADD_HOMEPAGE_ITEM_MODAL)
    .reduce((state, action) => {
        state.showingAddHomepageItemModal = false;
        state.columnId = null;
        state.sectionId = null;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/reducer.js